<!-- Start Main Container Area -->
<div class="main-container">
    <aside id="placid-aside" class="placid-aside">
        <div class="logo">
            <a routerLink="/">
                <img src="assets/img/RV-logo.png" alt="image">
            </a>
        </div>
        <div class="d-table">
            <div class="d-table-cell">
                <ul class="navbar-nav">
                    <li class="nav-item"><a class="nav-link active" href="#home">Home</a></li>
                    <li class="nav-item"><a class="nav-link" href="#about">About Us</a></li>
                    <li class="nav-item"><a class="nav-link" href="#amenities">Amenities</a></li>
                    <li class="nav-item"><a class="nav-link" href="#rates">Rates</a></li>
                    <li class="nav-item gallery"><button class="gallery sidebar-demo-control">Gallery</button></li>
                    <li class="nav-item"><a class="nav-link" href="#contact">Contact Us</a></li>
                </ul>
            </div>
        </div>
        <div class="aside-footer">

            <a href="https://www.campspot.com/park/cumby-rv-park" class="menu-btn">Reservations</a>
            <ul class="social">
                <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank"><i class="ri-facebook-box-line"></i></a></li>
                <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank"><i class="ri-twitter-line"></i></a></li>
                <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank"><i class="ri-linkedin-box-line"></i></a></li>
                <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank"><i class="ri-instagram-line"></i></a></li>
            </ul>
        </div>
        <div class="line"></div>
    </aside>

    <div id="main-content" class="main-content">
        <div class="responsive-burger-menu">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>

        <div class="main-banner banner-bg2 jarallax" data-jarallax='{"speed": 0.3}'>
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container">
                        <div class="main-banner-content">
                            <h1>The Perfect Vacation Getaway and Long-Term RV Community!</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div class="scroll-btn">
                <a href="#about">
                    <span class="mouse">
                        <span></span>
                    </span>
                </a>
            </div>
        </div>

        <section id="about" class="about-bg about-area plr-40 ptb-80">
            <div class="container">
                <div class="col-lg-11 col-md-12">
                    <div class="about-content">
                        <div class="section-title">
                            <h2>Cumby RV Park</h2>
                            <p>Our RV park, sprawling across nearly 75 acres in the charming town of Emory, is conveniently <b>located right off I-30 at Exit 110</b>. We offer spacious sites with full hook-ups, providing 20/30/50 amp electric for a variety of rigs. Enjoy complimentary basic Wi-Fi, with most sites accommodating parking for two vehicles. The park features wide, paved roads for easy access, a brand-new on-site laundry facility, and a fully-equipped fitness center. With on-site management, secure storage units, an <b>oversized pond perfect for fishing</b>, and an on-site restaurant, you’ll find everything you need for a relaxing and scenic stay at our park.</p>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-12"></div>
                            <div class="col-lg-5 col-md-12 text-center pb-25">
                                <img src="assets/img/rv-img01.png" alt="image">

                            </div>
                            <div class="col-lg-12 col-md-12 text-center">
                                <p><strong>Location</strong></p>
                                <p><b><u>10974 Black Jack Road, Cumby, TX 75433</u></b></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="about2" class="about-area plr-40 ptb-80">
            <div class="container">
                <div class="col-lg-11 col-md-12">
                    <div class="about-content">
                        <div class="section-title">
                            <h2>Cumby RV Storage</h2>
                            <p>Unlock extra space at our RV park with our <b>secure storage units</b>, available in popular sizes of <B>10x10</B> and <b>10x20</b>. Whether you need to store outdoor gear, seasonal items, or personal belongings, our storage solutions are designed for your convenience. Enjoy peace of mind with <b>24/7 access</b> to your unit in a fully secured facility, allowing you to come and go as you please. Experience the freedom of decluttering your RV site while knowing your possessions are safe and easily accessible, all within the beautiful surroundings of our expansive park!</p>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-12"></div>
                            <div class="col-lg-5 col-md-12 text-center pb-25">
                                <img src="assets/img/rv-img.png" alt="image">

                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="amenities" class="services-area plr-40 ptb-80">
            <div class="container">
                <div class="section-title">
                    <h2>About Amenities.</h2>
                </div>

                <div class="row">
                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-tent"></i>
                            </div>
                            <p>Large RV Sites with Full Hook-ups</p>
                        </div>
                    </div>
                   

                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-wifi"></i>
                            </div>
                            <p>Complimentary Basic Wi-Fi</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-parking"></i>
                            </div>
                            <p>Most Sites Have Parking for 2 Vehicles On-Site</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-washer"></i>
                            </div>
                            <p>New On-Site Laundry Facility</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-dumbbell"></i>
                            </div>
                            <p>Fitness Center</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-amplifier"></i>
                            </div>
                            <p>20/30/50 Amp Electric</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-wide"></i>
                            </div>
                            <p>Wide, Paved Roads</p>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-location"></i>
                            </div>
                            <p>On-Site Management</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">
                        <div class="single-services-box">
                            <div class="icon">
                                <i class="flaticon-tent"></i>
                            </div>
                            <p>Recreational Fishing Pond Spanning 11 Acres</p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-sm-6 col-md-6 text-center">

                    </div>
                </div>
            </div>
        </section>

        <section id="rates" class="works-area plr-40 ptb-80">
            <div class="container">
                <div class="section-title">
                    <h2>Daily Rates</h2>
                    <p>Our daily rates offer flexibility for short-term stays, making it perfect for visitors looking to enjoy a day of fishing or a brief getaway. This option allows guests to experience the beauty of our recreational pond without a long-term commitment, with pricing designed to accommodate casual anglers and families alike.</p>
                        <h2>Monthly Rates</h2>
                    <p>Our monthly rates are designed for those looking to enjoy the tranquil surroundings of our fishing pond for an extended period. This option is perfect for long-term RV stays, catering to a variety of guests, including seasonal workers, retirees, and individuals who travel for work. By choosing our monthly rates, guests can benefit from significant savings compared to daily bookings, allowing for unlimited access to fishing, walking trails, and all our amenities. Whether you're seeking a peaceful retreat, a place to unwind after a long workweek, or a temporary home while on assignment, our monthly rates offer flexibility and comfort for all.</p>
                </div>

                <div class="row">
                    <div class="col-lg-2 col-md-12"></div>
                    <div class="col-lg-8 col-md-12 text-center">
                        <div class="ratetable pt-25">
                            <h5>Rates</h5>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Site Type</th>
                                        <th>Daily</th>
                                        <th>Monthly</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>Deluxe Premium Waterfront RV Site</th>
                                        <td>$45.00*</td>
                                        <td>$199.00</td>
                                    </tr>
                                    <tr>
                                        <th>Deluxe Waterfront RV Site</th>
                                        <td>$45.00*</td>
                                        <td>$199.00</td>
                                    </tr>
                                    <tr>
                                        <th>Storage Unit 10X20</th>
                                        <td>N/A</td>
                                        <td>$75.00</td>
                                    </tr>
                                    <tr>
                                        <th>Storage Unit 10X10</th>
                                        <td>N/A</td>
                                        <td>$65.00</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="contact-area">
            <div class="container-fluid">
                <div class="col-lg-12 col-md-12 text-center">
                    <div class="contact-content jarallax" data-jarallax='{"speed": 0.3}'>
                        <div class="section-title">
                            <h2>Ready to Make Your Reservation?<br>
                                Book Online or Call Us at +1 (903) 994-4582</h2>
                            <a href="https://www.campspot.com/park/cumby-rv-park" class="menu-btn">REQUEST A RESERVATION</a>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <section  class="contact-area">
            <div class="container-fluid">
                <div class="col-lg-12 col-md-12 text-center">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3341.289554043881!2d-95.83357448480902!3d33.12775678086762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864bce1eb63caa6f%3A0x8f1739227b970b8f!2s11015%20I-30%20Frontage%20Rd%2C%20Cumby%2C%20TX%2075433%2C%20USA!5e0!3m2!1sen!2sin!4v1652290232832!5m2!1sen!2sin"
                        width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </section>
        <footer id="contact"  class="footer-area">
            <div class="container">
                <div class="footer-content">
                    <div class="logo">
                        <a routerLink="/">
                            <img src="assets/img/RV-logo-footer.png" alt="image">
                        </a>
                    </div>
                    <div class="footer-contact-info">
                        <ul>
                            <li><i class="ri-map-pin-line"></i> <a href="#" target="_blank">10974 Black Jack Road, Cumby, TX 75433.</a></li>
                            <li><i class="ri-phone-line"></i> <a href="tel:+19039944582">+1 (903) 994-4582</a></li>
                            <li><i class="ri-mail-line"></i> <a href="mailto:hello@blackjackrv.com">cumbyrvpark@gmail.com</a>
                            </li>
                        </ul>
                    </div>
                    <ul class="social">
                        <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank">Facebook</a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank">Twitter</a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank">Linkedin</a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=61551427012125" target="_blank">Instagram</a></li>
                    </ul>
                </div>
            </div>
            <div class="footer-bottom-area">
                <div class="container">
                    <p>Copyright @2024 cumbyrvpark.com. All Rights Reserved.</p>
                </div>
                <div class="line"></div>
            </div>
        </footer>
    </div>
</div>
<!-- End Main Container Area -->